import React, { useEffect, useState } from "react";
import { Footer, Navbar } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { dataWisata } from "../../store/dataWisata";
import { dataBudaya } from "../../store/dataBudaya";
// import { image1 } from "../../assets";

const DetailContent = () => {

    const { id } = useParams();
    const { type } = useParams();
    const navigate = useNavigate();
    const [content, setContent] = useState(dataBudaya);

    useEffect(() => {
        if (type === "wisata") {
            const wisata = dataWisata.find((wisata) => wisata.id === +id);
            if (wisata) {
                setContent(wisata)
            }
        } else if (type === "budaya") {
            const budaya = dataBudaya.find((budaya) => budaya.id === +id);
            if (budaya) {
                setContent(budaya)
            }
        }
    }, [id, type])

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <Navbar />
            <div className="flex justify-center">
                <div className="container pb-12 my-24 mt-32 shadow-md bg-white rounded-3xl px-12">
                    <div className="flex justify-start pt-12">
                        <FontAwesomeIcon className="text-3xl w-8 my-auto cursor-pointer" onClick={handleGoBack} icon={faArrowLeft} />
                        <h1 className="my-auto px-12 font-bold text-2xl">{content.name}</h1>
                    </div>
                    <div className="flex">
                        <div className="w-1/4 mr-12">
                            <img src={content.image_path} className="w-full mt-12 rounded-xl" alt="ini adalah gambar" />
                        </div>
                        <div className="w-3/4 mt-12 text-start">
                            <p className="text-base lg:text-lg text-justify indent-12">{content.description}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default DetailContent;